/**
 * 内置策略：分区调度 Zoning（设计文档 3.4 表 / F-007）。
 *
 * 楼层按电梯数均分为若干区，每台电梯绑定一个区，仅服务本区呼叫；
 * 本区车不可用（满载）时退化为最近可用车。
 */
import { greedyAssign } from '../greedy-assign';
import type { DispatchStrategy, InitContext, SnapshotView } from '../strategy-api';

const OUT_OF_ZONE = 1_000_000; // 非本区车的高代价

export function createZoningStrategy(id = 'zoning'): DispatchStrategy {
  let floors = 0;
  let carCount = 0;
  return {
    id,
    init(ctx: InitContext) {
      floors = ctx.floors ?? 0;
      carCount = ctx.carCount ?? 0;
    },
    allocate(view: SnapshotView) {
      const n = Math.max(1, carCount);
      const zoneSize = Math.max(1, Math.ceil(floors / n));
      return greedyAssign(view.cars, view.calls, (car, call) => {
        const zoneIdx = Math.min(n - 1, Math.floor(call.floor / zoneSize));
        const zoneCar = view.cars[zoneIdx];
        if (zoneCar && car.id === zoneCar.id) return 0; // 本区车
        return OUT_OF_ZONE + Math.abs(car.floor - call.floor); // 非本区：退化最近
      });
    },
  };
}
